export default [
  {
    dataIndex: 'version',
    key: 'version',
    title: 'Version'
  },
  {
    dataIndex: 'last_deployed',
    key: 'last_deployed',
    title: 'Last Deployed'
  }
]
